// Display labels of Stripe account values (business_type, capability status, account holder type)
// and ISO country codes, in the active Elakay language. The Stripe values themselves are never
// changed: forms still send "individual" / "company" and comparisons still use "active".
import { elakayAutoText, elakayIntlLocale } from "../includes/pageInside/dataElakay";

const BUSINESS_TYPE = {
  individual: ["h_stripe_bt_individual", "Individual"],
  company: ["h_stripe_bt_company", "Company"],
  non_profit: ["h_stripe_bt_non_profit", "Non-profit organization"],
  government_entity: ["h_stripe_bt_government", "Government entity"],
};

const CAPABILITY_STATUS = {
  active: ["h_stripe_cap_active", "Active"],
  inactive: ["h_stripe_cap_inactive", "Inactive"],
  pending: ["h_stripe_cap_pending", "Pending"],
  unrequested: ["h_stripe_cap_unrequested", "Not requested"],
};

const label = (map, value) => {
  const entry = map[String(value || "").toLowerCase()];
  return entry ? elakayAutoText(...entry) : (value || "");
};

export const stripeBusinessTypeLabel = (value) => label(BUSINESS_TYPE, value);
export const stripeCapabilityLabel = (value) => label(CAPABILITY_STATUS, value);

// "US" -> "United States" / "États-Unis" / "Estados Unidos"...; the code itself when the browser
// has no display name for it.
export const countryDisplayName = (code) => {
  const value = String(code || "").trim();
  if (!/^[A-Za-z]{2}$/.test(value)) return value;
  try {
    return new Intl.DisplayNames(elakayIntlLocale(), { type: "region" }).of(value.toUpperCase()) || value;
  } catch {
    return value;
  }
};
